// removed by extract-text-webpack-plugin
module.exports = {"root":"_1vi4wsi","root_isReady":"_2GWT5YQ","toggleLabel":"_2eDq3IH","toggle":"r5MrDeB","toggleContainer":"_3_zp8tg","menuBackdrop":"_1oYkOrs","chevron":"_1g9HCQq","menuBackdropLabel":"Tdrut89","userDisplayName":"_3AoPNVO","chevronSvg":"B4TkCgW"};


/*****************
 ** WEBPACK FOOTER
 ** ./app/components/Header/components/UserAccount/UserAccount.less
 ** module id = 737
 ** module chunks = 0
 **/